export default function Icon({ name }) {
  if (!name) return null;

  return <i className={name}></i>;
}